import { RequestService } from '../../../../../common/services/RequestService';
import { DOWNLOAD_CONTRACT_BY_ORDER_ID } from '../constants';

export const downloadContractByOrderIdRequest = async (profileId, orderId) => {
  const response = await RequestService.get(
    DOWNLOAD_CONTRACT_BY_ORDER_ID.replace('{order_id}', orderId).replace(
      '{profile_id}',
      profileId
    ),
    { responseType: 'blob' }
  );
  return response.data;
};
